/** Must match backend AmmoScoreCalculator.MinScoreToCreatePost */
export const MIN_AMMO_SCORE_TO_CREATE_POST = 10

/** Must match backend AmmoScoreCalculator.MinScoreToCreatePoll */
export const MIN_AMMO_SCORE_TO_CREATE_POLL = 50
export const MIN_AMMO_SCORE_TO_CREATE_CACHE = 200
export const MIN_AMMO_SCORE_TO_POST_IN_CACHE = 50

export function canCreateCommunityPost (user: {
  isAdmin?: boolean;
  isModerator?: boolean;
  ammoScore?: number;
} | null | undefined): boolean {
  if (!user) return false
  if (user.isAdmin || user.isModerator) return true
  return (user.ammoScore ?? 0) >= MIN_AMMO_SCORE_TO_CREATE_POST
}

export function canCreateCache (user: {
  isAdmin?: boolean;
  isModerator?: boolean;
  ammoScore?: number;
} | null | undefined): boolean {
  if (!user) return false
  if (user.isAdmin || user.isModerator) return true
  return (user.ammoScore ?? 0) >= MIN_AMMO_SCORE_TO_CREATE_CACHE
}

export function canCreatePoll (user: {
  isAdmin?: boolean;
  isModerator?: boolean;
  ammoScore?: number;
} | null | undefined): boolean {
  if (!user) return false
  if (user.isAdmin || user.isModerator) return true
  return (user.ammoScore ?? 0) >= MIN_AMMO_SCORE_TO_CREATE_POLL
}
